import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as PayverseLogo } from 'app/assets/image/common/payverse/payverse-logo.svg';
import { ReactComponent as PayverseIcon } from 'app/assets/image/common/payverse/payverse-icon.svg';
import { useTranslation } from 'react-i18next';
import dayjs, { Dayjs } from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { signature } from 'api/Api';

interface uiRequestBody {
  mid: string;
  clientKey: string;
  reqDate: string;
  orderId: string;
  productName: string;
  requestCurrency: string;
  requestAmount: number;
  returnUrl: string;
  sign: string;
}

const AmountPage = () => {
  const now: Dayjs = dayjs();
  const { t, i18n } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [amount, setAmount] = useState<number>(0);
  const [reqBody, setReqBody] = useState<uiRequestBody>({
    mid: '',
    clientKey: '',
    reqDate: dayjs(now).format('YYYYMMDDHHmmss'),
    orderId: dayjs(now).format('YYYYMMDDHHmmss'),
    productName: '',
    requestCurrency: '',
    requestAmount: 0,
    returnUrl: '',
    sign: '',
  });
  const [responseSign, setResponseSign] = useState<string>();
  const searchParams = useLocation().search;
  const paramMid = new URLSearchParams(searchParams).get('mid');
  const paramClientKey = new URLSearchParams(searchParams).get('clientKey');
  const paramCurrency = new URLSearchParams(searchParams).get('currency');
  const redirectUrl = window.location.href;

  // const getSign = useMutation(() => signature(reqBody), {
  //   onSuccess: data => {
  //     setReqBody(prev => ({
  //       ...prev,
  //       sign: data.data.sign,
  //     }));
  //     setResponseSign(data.data.sign);
  //   },
  //   onError: error => {
  //     navigate('/error');
  //   },
  // });

  const clearStorage = () => {
    window.sessionStorage.removeItem('auth');
    window.sessionStorage.removeItem('formSubmitted');
    window.sessionStorage.removeItem('clientKey');
    window.sessionStorage.removeItem('mid');
    window.sessionStorage.removeItem('redirectUrl');
  };

  useEffect(() => {
    clearStorage();
    if (paramClientKey && paramMid) {
      sessionStorage.setItem('mid', paramMid);
      sessionStorage.setItem('clientKey', paramClientKey);
    }
    //운영용
    if (
      paramMid === '202502007M' &&
      process.env.REACT_APP_ENV === 'production'
    ) {
      const redirectUrl =
        'https://order.payverseglobal.com/qrKey?key=20260828115205F20ADD';
      window.location.href = redirectUrl;
    }
    // dev용
    if (
      paramMid === '202608005M' &&
      process.env.REACT_APP_ENV === 'development'
    ) {
      const redirectUrl =
        'https://order-dev.payverseglobal.com/qrKey?key=202608201643021DA1C3';
      window.location.href = redirectUrl;
    }
    // const host = window.location.host;

    // const obj: uiRequestBody = {
    //   mid: paramMid || '',
    //   clientKey: paramClientKey || '',
    //   reqDate: dayjs(now).format('YYYYMMDDHHmmss'),
    //   orderId: dayjs(now).format('YYYYMMDDHHmmss'),
    //   productName: `${paramMid}-${dayjs(now).format('YYYYMMDD')}`,
    //   requestCurrency: paramCurrency || '',
    //   requestAmount: 0,
    //   returnUrl: `https://${host}/receipt`,
    //   sign: '',
    // };
    // setReqBody(obj);

    // const handleFocus = () => {
    //   if (inputRef.current) {
    //     setTimeout(() => {
    //       inputRef.current?.setSelectionRange(0, 0);
    //     }, 0);
    //   }
    // };

    // const inputEl = inputRef.current;
    // if (inputEl) {
    //   inputEl.addEventListener('foucs', handleFocus);
    //   return () => inputEl.removeEventListener('focus', handleFocus);
    // }
  }, []);

  // useEffect(() => {
  //   if (amount) {
  //     setReqBody(prev => ({ ...prev, requestAmount: amount }));
  //   }
  // }, [amount]);

  // useEffect(() => {
  //   if (responseSign) {
  //     //@ts-ignore
  //     window.payVerse.requestUI(reqBody);
  //   }
  // }, [responseSign]);

  // const clickPayBtn = async () => {
  //   window.sessionStorage.setItem('redirectUrl', redirectUrl);
  //   getSign.mutate();
  // };

  return (
    <></>
    // <Container>
    //   <HeaderBar>
    //     <Select
    //       value={i18n.language}
    //       onChange={e => i18n.changeLanguage(e.target.value)}
    //     >
    //       <option value="ko">한국어</option>
    //       <option value="en">English</option>
    //       <option value="jp">日本語</option>
    //       {/* 간체 */}
    //       <option value="cnsi">中文 （简体字）</option>
    //       {/* 번체 */}
    //       <option value="cntr">中文 （繁体字）</option>
    //     </Select>
    //   </HeaderBar>
    //   <LogoArea>
    //     <PayverseIcon width={32} height={31} />
    //     <PayverseLogo width={163} height={23} />
    //   </LogoArea>
    //   <CreditDiv>
    //     <Title>{t('amount')}</Title>
    //     <CreditBox>
    //       <p>{paramCurrency}</p>
    //       <InputWrp>
    //         <input
    //           ref={inputRef}
    //           type="number"
    //           name="amount"
    //           defaultValue={amount}
    //           onChange={(e: any) => setAmount(Number(e.target.value))}
    //         />
    //         <span>{paramCurrency === 'KRW' ? t('KRW') : paramCurrency}</span>
    //       </InputWrp>
    //     </CreditBox>
    //   </CreditDiv>
    //   <BottomWrp>
    //     <EventBtn onClick={clickPayBtn}>{t('pay_now')}</EventBtn>
    //     <RightString style={{ marginTop: 10 }}>
    //       Copyright &copy; 2024 eromnet Co.,Ltd. All rights reserved.
    //     </RightString>
    //   </BottomWrp>
    // </Container>
  );
};

export default AmountPage;

const Container = styled.div`
  width: 100%;
  max-width: 400px;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
`;

const HeaderBar = styled.div`
  max-width: 400px;
  height: 40px;
  padding: 10px 40px 0px 40px;
  display: flex;
  justify-content: flex-end;
  position: relative;
`;

const Select = styled.select`
  width: 120px;
  position: absolute;
`;

const LogoArea = styled.div`
  height: 70px;
  margin-top: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.p`
  font-size: 15px;
  font-weight: 600;
`;

export const BodyWrp = styled.div`
  border-radius: 5px;
  max-height: 300px;
  padding: 22px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 90%;
`;
export const CreditDiv = styled.div`
  padding: 0 40px;
  padding-bottom: 50%;
`;
export const CreditBox = styled.div`
  background: #e7f0ff;
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 10px 14px 30px 14px;
  p {
    font-size: 12px;
    font-weight: 600;
  }
`;

export const InputWrp = styled.div`
  border-bottom: 1px solid black;
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  padding-bottom: 6.5px;
  display: flex;
  align-items: center;
  justify-content: end;
  input {
    width: 70%;
    height: 100%;
    outline: none;
    border: none;
    text-align: right;
    background: transparent;
    font-weight: 600;
    font-size: 18px;
    margin-right: 7px;
  }
`;

export const BottomWrp = styled.div`
  display: flex;
  padding: 0 40px;
  flex-direction: column;
  align-items: center;
`;
export const EventBtn = styled.button`
  width: 100%;
  height: 46px;
  border-radius: 4px;
  background: #163b6a;
  color: white;
  border: none;
  font-size: 20px;
  font-weight: 600;
`;
export const RightString = styled.p`
  font-weight: 500;
  font-size: 9px;
  text-align: center;
  color: #a9a4a4;
`;
